<template>
	<div id="body">
		<div class="title">
			<i class="bi bi-person-check"></i> 会员登录
		</div>
		
		<el-form id="form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<div style="margin: 0 auto; margin-bottom: 20%; margin-top: -25%;">
				<img src="../../public/logo.png" style="margin-left: 20%; width: 70%; height: 70%;">
			</div>
	
			<el-form-item label="手机号码" prop="phone">
				<el-input v-model.trim="ruleForm.phone" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="pass">
				<el-input type="password" v-model.trim="ruleForm.pass" placeholder="请输入您的密码" show-password clearable></el-input>
			</el-form-item>

			<div style="float: right; position:relative; z-index: 2; margin-bottom: 20px;">
				<a href="forget">忘记密码?</a>
			</div>

			<el-form-item style="margin-left: -80px;">
				<el-button type="primary" @click="submitForm('ruleForm')" class="register">立即登录</el-button>
			</el-form-item>


			<div style="text-align: center;">
				你还没有账号?<a href="register">点击开始注册</a>
			</div>
		</el-form>

	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'register',
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			return {
				passNo:'',
				ruleForm: {
					phone: '',
					pass: '',
					openId:''
				},
				rules: {
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							min: 10,
							max: 11,
							message: '请输入11位的手机号码',
							trigger: 'blur'
						}
					],
					pass: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
				}
			};
		},
		methods: {
			...mapMutations(['changeStatus', 'changeLoginUserId','changeOpenId']),
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						//使用md5加密
						var salt = '1z2x3s6r9g8b7h';
						var str = "" + salt.charAt(0) + salt.charAt(2) + this.ruleForm.pass + salt.charAt(5) + salt
							.charAt(4);
						this.ruleForm.pass = this.$md5(str)
						
						//将用户token保存到vuex中
						this.$api({
							method: 'post',
							url: '/mobileLogin/login',
							params: {
								phone: this.ruleForm.phone,
								password: this.ruleForm.pass
							}
						}).then((res) => {
							if (res.data.code == 200) {
								this.$store.state.realName = res.data.data.realName
								this.changeStatus({status: res.data.data.status})
								this.changeLoginUserId({userId: res.data.data.userId})
								this.changeOpenId({openId: res.data.data.openId})
								if (res.data.data.status == 4) {
									this.$router.push('/search')
								}else if (res.data.data.status == 2) {
									this.$router.push('/uploadId')
								}else{
									this.ruleForm.pass = this.passNo
									this.$notify.info({
									  title: '该帐号还未认证，请前往会员中心查询您的当前状态',
									  showClose: false,
									  duration: 5000
									});
								}
							} else if (res.data.code == 500) {
								this.ruleForm.pass = ''
								this.$notify.error({
								  title: res.data.msg,
								  showClose: false,
								  duration: 5000
								});
							}
						});
					} else {
						this.$notify.error({
						  title: '请检查信息是否出错',
						  showClose: false,
						  duration: 5000
						});
						return false;
					}
				});
			},

		},
		created() {
			
		}
	}
</script>

<style scoped="scoped">
	a {
		text-decoration: none;
		font-size: 13px;
	}

	.title {
		margin-bottom: 0.5rem;
	}

	.yzm {
		position: absolute;
		float: right;
		margin-left: 5px;
		width: 85%;
	}

	.demo-ruleForm {
		width: 95%;
		padding-right: 5%;
		margin: 0 auto;
	}

	#upload {
		width: 100%;
	}

	.register {
		width: 100%;
	}

	#form {
		padding-top: 50%;
		padding-bottom: 50%;
		background-color: #FFFFFF;
	}
</style>
